import { TRandomTypeId as TRandomTypeId$1, Tag as Tag$1, live as live$1, next as next$1, nextBoolean as nextBoolean$1, nextInt as nextInt$1, nextIntBetween as nextIntBetween$1, nextRange as nextRange$1, shuffle as shuffle$1 } from '../../internal/stm/tRandom.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const TRandomTypeId = TRandomTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @internal
 * @since 2.0.0
 */

/**
 * The service tag used to access `TRandom` in the environment of an effect.
 *
 * @since 2.0.0
 * @category context
 */
const Tag = Tag$1;

/**
 * The "live" `TRandom` service wrapped into a `Layer`.
 *
 * @since 2.0.0
 * @category context
 */
const live = live$1;

/**
 * Returns the next number from the pseudo-random number generator.
 *
 * @since 2.0.0
 * @category random
 */
const next = next$1;

/**
 * Returns the next boolean value from the pseudo-random number generator.
 *
 * @since 2.0.0
 * @category random
 */
const nextBoolean = nextBoolean$1;

/**
 * Returns the next integer from the pseudo-random number generator.
 *
 * @since 2.0.0
 * @category random
 */
const nextInt = nextInt$1;

/**
 * Returns the next integer in the specified range from the pseudo-random number
 * generator.
 *
 * @since 2.0.0
 * @category random
 */
const nextIntBetween = nextIntBetween$1;

/**
 * Returns the next number in the specified range from the pseudo-random number
 * generator.
 *
 * @since 2.0.0
 * @category random
 */
const nextRange = nextRange$1;

/**
 * Uses the pseudo-random number generator to shuffle the specified iterable.
 *
 * @since 2.0.0
 * @category random
 */
const shuffle = shuffle$1;

export { TRandomTypeId, Tag, live, next, nextBoolean, nextInt, nextIntBetween, nextRange, shuffle };
